/* withFlexibleUIBlockCardStyle.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./withFlexibleUIBlockCardStyle.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { N40 } from '@atlaskit/theme/colors';
var flexibleBlockCardStyle = null;
export var withFlexibleUIBlockCardStyle = function withFlexibleUIBlockCardStyle(FlexibleBlockCardView) {
  return function (props) {
    return /*#__PURE__*/React.createElement("div", {
      className: ax(["_1g96pd34 _1qo3n8v0"]),
      style: {
        "--_vzvmm2": ix("1px solid ".concat("var(--ds-border, ".concat(N40, ")")))
      }
    }, /*#__PURE__*/React.createElement(FlexibleBlockCardView, props));
  };
};